import { Routes, Route, Navigate } from 'react-router-dom';
import { SharedLayout } from './components/layout/SharedLayout';
import { ROUTES } from './lib/constants';
import HomePage from './pages/HomePage';
import MapExplorer from './pages/MapExplorer';
import RankingsTable from './pages/RankingsTable';
import MetroDetail from './pages/MetroDetail';
import CompareView from './pages/CompareView';
import ProvidersTable from './pages/ProvidersTable';

/**
 * Top-level router. All six pages ship behind the SharedLayout:
 * Home, Map, Rankings, Detail, Compare, Providers (the original
 * "three pages for V1" scope note predated D7 completion, 2026-06-09).
 * Unknown routes redirect home via the catch-all.
 *
 * Route registrations are pinned by `App.test.tsx` (Rule 13 route-
 * resolution contract): every ROUTES entry must mount its page, and
 * removing a registration turns that suite RED.
 */
export default function App() {
  return (
    <Routes>
      <Route element={<SharedLayout />}>
        <Route path={ROUTES.home} element={<HomePage />} />
        <Route path={ROUTES.map} element={<MapExplorer />} />
        <Route path={ROUTES.rankings} element={<RankingsTable />} />
        <Route path={ROUTES.detail} element={<MetroDetail />} />
        <Route path={ROUTES.compare} element={<CompareView />} />
        <Route path={ROUTES.providers} element={<ProvidersTable />} />
        <Route path="*" element={<Navigate to={ROUTES.home} replace />} />
      </Route>
    </Routes>
  );
}
